// Smooth-scroll from the PDP reviews summary to the reviews section.
// Loaded by the reviews-carousel section, so it only runs when there is a
// reviews section on the page to scroll to. Enhances any element marked with
// [data-scroll-to-reviews] (the product reviews summary) into a clickable,
// keyboard-accessible trigger. If no reviews section is present the trigger is
// left inert.
if (!window.DigitalizModules) window.DigitalizModules = {};
if (!window.DigitalizModules.ReviewsScroll) {
  class ReviewsScroll {
    constructor(el) {
      this.el = el;
      this.target = document.querySelector('[data-reviews-section]');
      if (!this.target) return;
      this.init();
    }

    init() {
      this.el.setAttribute('role', 'button');
      this.el.setAttribute('tabindex', '0');
      this.el.classList.add('is-clickable');

      this.onClick = this.scrollToReviews.bind(this);
      this.onKey = (event) => {
        if (event.key === 'Enter' || event.key === ' ' || event.key === 'Spacebar') {
          event.preventDefault();
          this.scrollToReviews();
        }
      };

      this.el.addEventListener('click', this.onClick);
      this.el.addEventListener('keydown', this.onKey);
    }

    scrollToReviews() {
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const offsetRaw = getComputedStyle(document.documentElement)
        .getPropertyValue('--sticky-header-offset');
      const offset = parseFloat(offsetRaw) || 0;
      const top = this.target.getBoundingClientRect().top + window.scrollY - offset;

      window.scrollTo({ top: top, behavior: reduceMotion ? 'auto' : 'smooth' });
    }

    destroy() {
      this.el.removeEventListener('click', this.onClick);
      this.el.removeEventListener('keydown', this.onKey);
    }
  }

  window.DigitalizModules.ReviewsScroll = ReviewsScroll;

  document.querySelectorAll('[data-scroll-to-reviews]').forEach((el) => {
    new ReviewsScroll(el);
  });
}
